import { render } from "./NewsSmallBox.vue?vue&type=template&id=6bffd4a5&scoped=true"
import script from "./NewsSmallBox.vue?vue&type=script&lang=js"
export * from "./NewsSmallBox.vue?vue&type=script&lang=js"

import "./NewsSmallBox.vue?vue&type=style&index=0&id=6bffd4a5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bffd4a5"]])

export default __exports__